import * as React from 'react';

import { Props } from './types';
import { arePropsEqual } from './utils';

const MaximizeIcon = React.memo(
  ({ className }: Props) => (
    <svg
      data-testid="maximize-icon"
      className={className}
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24"
    >
      <path
        d="M19 15.5C19 15.5 19 16.69 19 19H5V5C7.52 5 8.5 5 8.5 5"
        stroke="#0B52B1"
        strokeWidth="1.8"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19 5L10.53 13.47"
        stroke="#0B52B1"
        strokeWidth="1.8"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.4 5H19V10.6"
        stroke="#0B52B1"
        strokeWidth="1.8"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  arePropsEqual
);

export default MaximizeIcon;
